module.exports = __webpack_public_path__ + "static/media/arrow-right.f3976f21.svg";